export type ArchiveDownloadResult = {
    fileName?: string | undefined;
    isPartial: boolean;
    downloadUrl: string;
    expiresAt?: string | undefined;
};

export const downloadArchiveFromUrl = (downloadUrl: string, fileName?: string) => {
    const link = document.createElement('a');

    try {
        link.href = downloadUrl;
        if (fileName) {
            link.download = fileName;
        }
        document.body.appendChild(link);
        link.click();
    } finally {
        link.remove();
    }
};
